export enum S3Operation {
    UPLOAD = 'upload',
    DOWNLOAD = 'download',
    DELETE = 'delete',
}
